"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/schedule-success.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M207.3 170.1h-14.4c-3.3 0-6-2.7-6-6s2.7-6 6-6h14.4c3.3 0 6 2.7 6 6s-2.7 6-6 6zm-73.1-6c0-3.3-2.7-6-6-6h-14.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h14.4c3.4 0 6-2.7 6-6zm158.1 0c0-3.3-2.7-6-6-6h-14.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h14.4c3.3 0 6-2.7 6-6zm-79 43.1c0-3.3-2.7-6-6-6h-14.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h14.4c3.3 0 6-2.7 6-6zm-79.1 0c0-3.3-2.7-6-6-6h-14.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h14.4c3.4 0 6-2.7 6-6zm79.1 43.1c0-3.3-2.7-6-6-6h-14.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h14.4c3.3 0 6-2.7 6-6zm-79.1 0c0-3.3-2.7-6-6-6h-14.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h14.4c3.4 0 6-2.7 6-6zM400 286.2c0 46.9-38.1 85-85 85-37.2 0-69-24.1-80.4-57.5H64.4c-11.7 0-21.2-9.5-21.2-21.2V78.7c0-11.7 9.5-21.2 21.2-21.2h50.7V34.8c0-3.3 2.7-6 6-6s6 2.7 6 6v22.7h146V34.8c0-3.3 2.7-6 6-6s6 2.7 6 6v22.7h50.7c11.7 0 21.2 9.5 21.2 21.2v133.6c25.6 14.6 43 42.2 43 73.9zM55.2 100.6h289.6V78.7c0-5.1-4.1-9.2-9.2-9.2h-50.7V85c0 3.3-2.7 6-6 6s-6-2.7-6-6V69.5h-146V85c0 3.3-2.7 6-6 6s-6-2.7-6-6V69.5H64.4c-5 0-9.2 4.1-9.2 9.2v21.9zM230 286.2c0-46.9 38.1-85 85-85 10.5 0 20.6 1.9 29.9 5.4v-94H55.2v179.9c0 5 4.1 9.2 9.2 9.2h167c-.9-5-1.4-10.2-1.4-15.5zm158 0c0-40.2-32.8-73-73-73-40.3 0-73 32.8-73 73 0 40.3 32.8 73 73 73s73-32.8 73-73zm-76 24.3l43.1-43.1c2.3-2.3 2.3-6.1 0-8.5s-6.1-2.3-8.5 0l-38.9 38.9-17.3-17.3c-2.3-2.3-6.1-2.3-8.5 0-2.3 2.3-2.3 6.1 0 8.5l21.5 21.5c1.1 1.1 2.6 1.8 4.2 1.8 1.8-.1 3.3-.7 4.4-1.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;